import { render, staticRenderFns } from "./DeviceSettingsCard.vue?vue&type=template&id=2f876fde&scoped=true&"
import script from "./DeviceSettingsCard.vue?vue&type=script&lang=js&"
export * from "./DeviceSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSettingsCard.vue?vue&type=style&index=0&id=2f876fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f876fde",
  null
  
)

export default component.exports